var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"alert"},[_c('figure',{staticClass:"alert__figure"},[_c('SvgIcon',{attrs:{"id":"action-info"}})],1),_c('p',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }